import { Chip } from '@mui/material';
import { Order_Status_Enum } from '@kheops/graphql';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { currentContextAtom } from '../../state';
import { contextToActionNeededStatusMap } from '../state/state';
import { getOrderStatusIntl } from '../../common/utils/order.utils';
import { DISPUTE_STATUSES } from '../../hooks/useOrders';

interface OrderStatusChipProps {
  status: Order_Status_Enum;
}

export default function OrderStatusChip({ status }: OrderStatusChipProps): React.JSX.Element {
  const { t } = useTranslation('order-status');
  const { realm } = useAtomValue(currentContextAtom);

  const chipColor = useMemo(() => {
    if (DISPUTE_STATUSES.includes(status)) {
      return 'errorContainer';
    }

    const isActionNeeded = contextToActionNeededStatusMap.get(realm)?.includes(status);
    if (isActionNeeded) {
      return 'primary';
    }

    return undefined;
  }, [status, realm]);

  return (
    <Chip
      label={t(`order-status:${getOrderStatusIntl(status, realm)}`)}
      variant="tag"
      color={chipColor}
    />
  );
}
